export default {
  poll: 'Hlasování',
  feed: 'Zprávy',
  units: 'Jednotky',
  building: 'Detail domu',
  files: 'Úložiště souborů',
  registry: 'Rejstříky',
  deadlines: 'Termíny',
  issues: 'Závady a podněty',
  services: 'Služby a partneři',
  memberBenefits: 'Výhody pro vás',
  more: 'Další',
  unitsHint: 'Doporučujeme začít vyplněním kontaktních údajů vlastníků',
  profile: 'Nastavení',
  logout: 'Odhlásit se',

  BuildingSelect: {
    title: 'Vyberte dům',
    subtitle: 'Vyberte dům který chcete nastavit jako aktivní.',
    searchPlaceholder: 'Hledat dům…',
    searchEmpty: 'Žádný dům neodpovídá hledání.',
    addBuilding: 'Přidat další dům',

    Add: {
      title: 'Přidání dalšího domu',
      text: 'Další dům přidáte běžnou registrací domu. Jste přihlášeni jako {{email}} — registrace se vás pouze zeptá, zda chcete dům přidat pod tento účet.',
      tipTitle: 'Chcete dům přidat pod jiný účet?',
      tipText:
        'V kroku s údaji o uživateli zadejte e-mail účtu, pod který chcete dům registrovat. Systém vás poté vyzve k přihlášení zadáním hesla.',
      continue: 'Pokračovat na registraci domu',
      back: 'Zpět na výběr domu',
    },
  },

  Subscription: {
    inGracePeriodText: 'Předplatné pro tuto budovu vyprší',
    isExpiredText: 'Předplatné pro tuto budovu\u00a0vypršelo.',
    warning: 'Aplikace je nyní v omezeném režimu',
    error: 'Aplikace je nyní v neplaceném režimu',
    demo: 'DEMO režim – omezené úpravy',
    expiring_one: 'Licence končí za {{count}} den',
    expiring_few: 'Licence končí za {{count}} dny',
    expiring_other: 'Licence končí za {{count}} dní',
    expiringToday: 'Licence končí dnes',
    pending: 'Čekáme na platbu proforma faktury',
    pendingNumber: 'Čekáme na platbu proforma faktury {{number}}',
    order: 'Objednat služby',
    extend: 'Prodloužit licenci',
    showOrder: 'Zobrazit objednávku',
  },
};
